import { api } from "@/lib/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from "../use-toast";
import {
  getPaymentAdjustmentQueryOptions,
  getPaymentAdjustmentsQueryOptions,
} from "./get.hooks";

export function useDeletePaymentAdjustment(opts?: {
  onSuccess?: () => void;
  onError?: () => void;
}) {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: (id: string) =>
      api.delete<void>(`/api/payment-adjustments/$id`, undefined, {
        pathReplace: { $id: id },
      }),
    onSuccess: (_, id) => {
      queryClient.setQueryData(
        getPaymentAdjustmentsQueryOptions.queryKey,
        (old) => old?.filter((c) => c.id !== id),
      );
      queryClient.resetQueries({
        queryKey: getPaymentAdjustmentQueryOptions(id).queryKey,
      });
      toast({
        title: "toast.paymentAdjustmentDeleted",
        variant: "success",
      });
      opts?.onSuccess?.();
    },
    onError: () => {
      toast({
        title: "toast.deletePaymentAdjustmentError",
        variant: "destructive",
      });
      opts?.onError?.();
    },
  });
}
